// Preserve the original 382 x 421 artwork. The complete outer gold badge is
// centred at (241.5, 160), radius 108; exclude only its exterior background.
const sgpLogo = `${process.env.PUBLIC_URL || ""}/branding/sgp-approved.png`;
const neoLogo = `${process.env.PUBLIC_URL || ""}/branding/neo-approved.png`;

export const COMPANY_BRANDS = {
  sgp: {
    id: "sgp",
    shell: "heritage",
    logo: sgpLogo,
    logoClass: "absolute !h-[194.9074%] !w-[176.8519%] !max-w-none left-[-61.8056%] top-[-24.0741%]",
    markClass: "relative [clip-path:circle(50%)] scale-110",
  },
  prachi: {
    id: "prachi",
    shell: "prachi",
    logo: null,
    logoClass: "",
    markClass: "rounded-2xl bg-[#eaf0f5] text-[#354f63]",
  },
  neo: {
    id: "neo",
    shell: "neo",
    logo: neoLogo,
    logoClass: "object-contain",
    markClass: "bg-white",
  },
};

export function companyBrand(company) {
  return COMPANY_BRANDS[company?.id] || {
    id: company?.id || "company",
    shell: company?.theme?.shell || "heritage",
    logo: null,
    logoClass: "",
    markClass: "rounded-xl bg-white text-slate-900",
  };
}

export function CompanyMark({ company, className = "h-12 w-12", imageClassName = "h-full w-full" }) {
  const brand = companyBrand(company);
  if (!brand.logo) return null;
  return (
    <div title={company?.name || ""} className={`${className} ${brand.markClass} flex shrink-0 items-center justify-center overflow-hidden`}>
      <img src={brand.logo} alt={company?.name || ""} className={`${imageClassName} ${brand.logoClass}`} />
    </div>
  );
}
